export const parseTimeForTimer = (time: number, separator = ':'): string => {
  const m = Math.trunc(time / 60);
  const minutes = `${m}`.length === 1 ? `0${m}` : m;
  const s = time - m * 60;
  const seconds = `${s}`.length === 1 ? `0${s}` : s;
  return `${minutes}${separator}${seconds}`;
};

export const onlyNumbers = (value: string): string => value.replace(/[^0-9]/g, '');

export const IBANValues = (v: string): string => v.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

export const trim = (value: string) => value.trim();

// formatMoney For Indian number system:
export const formatMoney = (num: string | number | undefined): string => {
  if (num === undefined) {
    return '';
  }

  return num.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'INR',
  });
};

export const formatMoneyWithOneDigit = (num: string | number): string =>
  num?.toLocaleString('en-IN', {
    maximumFractionDigits: 1,
    style: 'currency',
    currency: 'INR',
  });

export const parseAmount = (value: string | number): number => +onlyNumbers(trim(value.toString()));
export const parseAmountWithDecimals = (value: any): string =>
  (Math.round(value * 100) / 100).toFixed(2);
export const parseTerm = (value: string | number): number => +onlyNumbers(trim(value.toString()));
export const parsePercent = (value: string | number): number => +value * 100;

export const onlyAmountWithDecimals = (v: string): string => v.replace(/[^\d*(.{0,2})?$]/g, '');

export const onlyLatinas = (v: string): string => v.replace(/[^a-zA-Z]/g, '');
export const onlyLatinasWithSpace = (v: string): string => v.replace(/[^a-zA-Z ]/g, '');
export const onlyLatinasAndSymbols = (v: string): string => v.replace(/[^a-zA-Z \-—']/g, '');
export const onlyCyrillic = (v: string): string => v.replace(/[^а-яА-яЁё]/g, '');
export const onlyCyrillicWithSpace = (v: string): string => v.replace(/[^а-яА-яЁё ]/g, '');
export const onlyCyrillicAndNumbers = (v: string): string => v.replace(/[^а-яА-яЁё0-9]/g, '');
export const onlyUpperCase = (v: string): string => v.toUpperCase();
export const onlyLowerCase = (v: string): string => v.toLowerCase();
export const maxLength =
  (l: number) =>
  (v: string): string =>
    v.slice(0, l);
export const capitalizeFirstLetter = (v: string) => v.charAt(0).toUpperCase() + v.slice(1);

export const normalizeNumberFormat = (v: string) => {
  const value = new Intl.NumberFormat('ru-RU').format(+onlyNumbers(v));
  return value === '0' ? '' : value;
};

export const formatNumber = (value: string | number) =>
  value === '0' || value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
